<template>
  <div class="assignment">
      <!-- <create-dialog v-model="dialog" :item="item" @fetch="fetchData"></create-dialog> -->
       
      <v-card class=" rounded-lg" elevation="1">
          <v-card-title class="text-subtitle-1">
            Danh sách dữ liệu <span class="mr-4"></span>
            <month-picker v-model="month" label="Chọn tháng" width="7rem" dense outlined></month-picker>
            <v-divider vertical class="mx-4"></v-divider>
            <v-btn color="green" class="ml-n4" text style="text-transform: capitalize;">Xuất excel</v-btn>
              <v-spacer></v-spacer>

              <v-text-field outlined hide-details v-model="search" style="max-width: 200px;" dense label="Tìm kiếm" persistent-placeholder></v-text-field>
              <v-btn @click="fetchData" class="mx-3" color="orange" icon>
                  <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-btn icon @click="adminDialog=!adminDialog" color="primary"> <v-icon>mdi-plus</v-icon> </v-btn>
              <!-- <v-card-text class="pa-0 mt-2">
                <v-chip-group
                    column class="mx-n2"
                >
                    <v-text-field label="Mã NS"
                        dense hide-details outlined background-color="transparent" flat persistent-placeholder placeholder=""  style="min-height: 20px; max-width: 250px;" class="mx-2 my-1">
                    </v-text-field>
                    
                    <v-text-field label="Từ"
                        dense hide-details outlined background-color="transparent" flat persistent-placeholder placeholder=""  style="min-height: 20px; max-width: 250px;" class="mx-2 my-1">
                    </v-text-field>
                    
                    <v-text-field label="Đến"
                        dense hide-details outlined background-color="transparent" flat persistent-placeholder placeholder=""  style="min-height: 20px; max-width: 250px;" class="mx-2 my-1">
                    </v-text-field>

                    <v-btn color="teal darken-4" class="my-auto ml-2 rounded-xl" dark @click="fetchData(true)" 
                    style="width:120px; text-transform: capitalize;" small><v-icon left>mdi-magnify</v-icon> Tìm kiếm</v-btn>
                </v-chip-group>
              </v-card-text> -->
          </v-card-title>
          <!-- ******** dialog ADMIN ********  -->
          <v-dialog v-model="adminDialog" max-width="600px">
              <v-card>
                  <v-card-title>
                      Tạo mới <v-spacer></v-spacer> <v-icon small @click="adminDialog=false">mdi-close</v-icon>
                  </v-card-title>
                  <v-form @submit.prevent="saveData" v-model="valid" ref="form">
                      <v-card-text>
                          <v-row>
                              <v-col cols="12">
                                  <v-autocomplete v-model="form.employeeCode"  @update:search-input="fetchEmployee" label="Nhân viên *" 
                                      :filter="customFilter"
                                      hide-no-data :items="employees" item-text="name" item-value="code">
                                      <template v-slot:item="data">
                                          <strong>{{ data.item.code }}: </strong> {{` ${data.item.name} - ${data.item.department}`}}
                                      </template>
                                  </v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="6">
                                <v-text-field type="date" v-model="form.validFrom" label="Từ ngày" hide-details></v-text-field>
                              </v-col>
                              
                              <v-col cols="12" md="6">
                                <v-text-field type="date" v-model="form.validTo" label="Đến ngày" hide-details></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                  <v-textarea v-model="form.description" solo flat outlined label="Diễn giải">
                                  </v-textarea>
                              </v-col>
                          </v-row>
                      </v-card-text>
                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn dark color="primary" type="submit" small>
                              Lưu
                          </v-btn>
                          <v-spacer></v-spacer>
                      </v-card-actions>
                  </v-form>
              </v-card>
          </v-dialog>
          <v-data-table
              :mobile-breakpoint="0"
              height="600px" fixed-header
              :headers="headers"
              :items="items"
              :loading="isLoading"
              loading-text="Đang tải dữ liệu..."
              :search="search"
              :footer-props="{
                  itemsPerPageOptions:[
                  50, 100, 200
                  ]
              }"
          >
              <template v-slot:[`item.actions`]="{item}" >
                  <!-- ********* Edit ****** -->
                  <v-btn icon v-if="item.status == 0" class="" color="primary" @click="accept(item)">
                      <v-icon >
                          mdi-check-circle
                      </v-icon>
                  </v-btn>

                  <!-- ********* Xoa ****** -->
                  <v-btn icon class="" v-if="item.status == 0" color="error" @click="decline(item)" >
                      <v-icon >
                          mdi-close-circle
                      </v-icon>
                  </v-btn>

                  <!-- ********* Undo ****** -->
                  <v-btn x-small class="mx-1 elevation-1" dark v-if="item.status != 0" color="blue-grey" @click="undo(item)" >
                      <v-icon small   >
                          mdi-undo
                      </v-icon>Hoàn tác
                  </v-btn>

              </template>
              <template v-slot:[`item.delete`]="{ item }">
                  <!-- ********* Xóa ****** -->
                  <v-btn x-small class="mx-1 elevation-1" dark color="error" @click="remove(item)">
                      <v-icon small   >
                          mdi-trash
                      </v-icon>Xóa 
                  </v-btn>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                  <v-chip :color="$helper.formatStatus(item.status).color" small dark>
                      <strong> {{$helper.formatStatus(item.status).text}}</strong>
                  </v-chip>
              </template>
              <template v-slot:[`item.departmentName`]="{ item }">
                  <v-chip class="ma-2 caption font-weight-bold" color="teal darken-4" label text-color="white" >
                  <v-icon left>
                      mdi-store
                  </v-icon>
                  {{item.departmentName}}
                  </v-chip>
              </template>

              <template v-slot:[`item.employeeName`]="{ item }">
                  <b>{{item.employeeName}}</b>
              </template>
              <template v-slot:[`item.validFrom`]="{ item }">
                  {{formatDate(item.validFrom)}}
              </template>
              <template v-slot:[`item.validTo`]="{ item }">
                  {{formatDate(item.validTo)}}
              </template>
              <template v-slot:[`item.confirmDate`]="{ item }">
                  {{formatDate(item.confirmedDate)}}
              </template>
          </v-data-table>
      </v-card>
      <!-- ************** DELETE CONFIRMATION *************** -->
      <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
              <v-card-title>Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
              <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogDelete=false">Thoát</v-btn>
              <v-btn color="red" dark @click="cfmDeleteItem" class="rounded-lg">OK</v-btn>
              <v-spacer></v-spacer>
              </v-card-actions>
          </v-card>
      </v-dialog>
  </div>
</template>

<script>
import http from '@/components/services/http-common';
import ApiServices from '@/components/services/ApiServices';
import DataFilter from '@/components/DataFilter';
// import CreateDialog from './Create.vue';
import * as moment from "moment/moment";
import {headers} from "./headers"

import {get, post, remove} from './api'

export default {
  name: "Attendance",
  components: {
      'data-filter': DataFilter,
      // 'create-dialog': CreateDialog,

  },
  props: ["icon"],
  watch: {
      dialog(val) {
          if(!this.dialog)
              this.item=null;
      },
      tableParams: {
          handler (val) {
              this.fetchData();
          },
          deep: true,
      },
      filters: {
          handler (val) {
              this.tableParams.page=1;
              // this.fetchData();
          },
          deep: true,
      },
      month:{
          handler(val){
              this.filters.from=moment(val, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
              this.filters.to=moment(val, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
              this.fetchData()
          }
      }
  },
  computed: {
      params: function() {
          return {...this.tableParams, ...this.filters}
      }
  },
  data () {
      return {
          ROOT_URL: "FacialCheckinDisables/",
          BUSINESSTYPE_URL: "businesstypes/",
          adminDialog: false,
          exportPromt: false,
          search: '',
          //filter
          tableParams: {
              sortBy: [],
              sortDesc: [],
              page: 1,
              pageSize: 10000
          },

          month: moment().format("YYYY-MM"),
          leavePlans:[],
          filters:{
              status: -1,
              code: null,
              employeeCode: null,
              employeeName: null,
              departmentCode: null,
              businessTypeCode:null,
              from: moment().startOf("month").format("YYYY-MM-DD"),
              to: moment().endOf("month").format("YYYY-MM-DD"),
              date: null,
          },
          rowCount: 0,

          departmentSearch:null,
          departments: [],

          filter: {
              menu: false,
              search: "",
              searchAttr: "name",
              searchAttrs: undefined,
              FilterAttrs: [],
              FilterOn:["DepartmentTypeCode"],
              from: undefined,
              to: undefined,
              fromOns: [
              ],
              fromOn: "",
          },
          
          // VIEW DATA
          filterOpen: 1,

          //DATA TABLE
          totalItem: 0,
          items: [],
          options: {},
          isLoading: true,

          dialog: false, item: null,
          dialogDelete: false,
          targetItem: undefined,

          headers: headers,

          valid: false,
          employees:[],
          formData: {
              businessTypes: [],
          },
          form: {
            employeeCode: '',
            validFrom: '',
            validTo: '',
            description: '',

          },

          defaultForm: {
            employeeCode: '',
            validFrom: '',
            validTo: '',
            description: '',
          },
      }
  },
  methods: {
      customFilter(item, queryText, itemText) {
          return itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.code.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      },
      formatDate(value) {
          return moment(value).format("DD/MM/YYYY");
      },
      formatStatus(value){
          switch(value){
              case 0:{
                  return "Chờ duyệt";
              }
              case 1:{
                  return "Chấp nhận";
              }
              case 2:{
                  return "Từ chối";
              }
          }
      },
      formatTime(value) {
          return moment(value).format("DD/MM/YYYY HH:mm:ss");
      },
      fetchLeavePlan(){
          ApiServices.fetchLeavePlan().then(res=>{
              this.leavePlans = res.data;
          })
      },
      fetchDepartment() {
          return http.get("departments/fetch").then(res => {
              this.departments = res.data;
          })
      },
      fetchData () {
          this.isLoading = true;
          return get()
          .then(d => {
              this.items = d.data;
          })
          .catch(err => {
          })
          .finally(() => {
              this.isLoading = false;
          })
      },
      
      saveData() {
          this.$refs.form.validate();
          if(this.valid)
          {
              return post(this.form)
              .then(res => {
                  this.fetchData();
                  this.adminDialog = false;
              })
              .catch(err => {
              });
          }
      },
      
      accept(item) {
          return http.get(this.ROOT_URL + "accept/" + item.code).then(res => {
              this.fetchData();
          }).catch(err => {
              console.log(err)
          });
      },

      decline(item) {
          return http.get(this.ROOT_URL + "decline/" + item.code).then(res => {
              this.fetchData();
          }).catch(err => {
              console.log(err)
          });
      },

      undo(item) {
          http.get(this.ROOT_URL + "undo/" + item.code).then(res => {
              this.fetchData();
          }).catch(err => {
              console.log(err)
          });
      },
      edit(item){
          this.item = item;
          this.dialog = true;
      },
      
      remove(item){
          this.dialogDelete = true;
          this.targetItem = item;
      },
      cfmDeleteItem() {
          return remove(this.targetItem.id).then(res => {
              this.fetchData();
              this.dialogDelete = false;
          })
      },

      fetchBusinessType () {
          return http.get(this.BUSINESSTYPE_URL)
          .then(res => {
              this.formData.businessTypes = res.data.items;
          }).catch(err => {throw err})

      },
      fetchEmployee(val){
          ApiServices.fetchEmployee(val).then(res=>{
              this.employees = res.data;
              console.log(res.data);
          })
      },
  },
  created () {
      this.fetchData();
      this.fetchBusinessType();
      this.fetchDepartment()
  }
}
</script>
<style scoped>
  /* ::v-deep table > tbody > tr:nth-child(1)>td {
      padding-right: 1px !important;
      padding-left: 1px !important;
  } */
</style>